// extracted by mini-css-extract-plugin
module.exports = {"onlyOne":"style__onlyOne__piuFl","unlinkButton":"style__unlinkButton__X09uH","buttonStyle":"style__buttonStyle__vlBUq","tableWrapper":"style__tableWrapper__BMRty"};